import { render } from "./FooTr.vue?vue&type=template&id=13f95b35"
const script = {}

import "./FooTr.vue?vue&type=style&index=0&id=13f95b35&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__